<template>
  <div class="mt-8">
    <tables
      :dataset="_dataset"
      type="reconciliation"
      :queryParams.sync="queryParams"
      :headers="reconHeaders"
      tab="oneway"
    >
      <template v-slot:content="slotProps">
        <div v-if="showMobileView">
          <v-row>
            <v-col cols="6" class="px-0 pt-0 pb-2">
              <v-card-text
                class="py-0 text-h6 font-weight-medium secondary--text"
              >
                {{ slotProps.data.screen_id }}
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1 d-flex justify-end">
              <v-btn
                color="black"
                class="white--text text-capitalize mr-4"
                height="26"
                width="80"
                @click="openEmail(slotProps.data.group.contact_email)"
              >
                <v-icon small>mdi-email</v-icon>
                Email
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />
          <v-row>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text class="pb-0 pt-2">
                RA#
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text
                class="text-right pb-0 pt-2 text-subtitle-2 font-weight-medium"
              >
                {{ slotProps.data.rental_agreement_number }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text class="py-0 pr-0">
                Original Location
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text
                class="text-right py-0 text-subtitle-2 font-weight-medium"
              >
                {{ slotProps.data.group.name }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="7" class="px-0 py-1">
              <v-card-text class="py-0 pr-0">
                Destination Location
              </v-card-text>
            </v-col>
            <v-col cols="5" class="px-0 py-1">
              <v-card-text
                class="text-right py-0 text-subtitle-2 font-weight-medium"
              >
                {{ slotProps.data.destination }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text class="py-0">
                Rental Date
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text
                class="text-right py-0 text-subtitle-2 font-weight-medium"
              >
                {{ setTime(slotProps.data.start_at) }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text class="py-0">
                Due Date
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text
                class="text-right py-0 text-subtitle-2 font-weight-medium"
              >
                {{ setTime(slotProps.data.expected_end_at) }}
              </v-card-text>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text class="py-0">
                Status
              </v-card-text>
            </v-col>
            <v-col cols="6" class="px-0 py-1">
              <v-card-text
                class="text-right py-0 text-subtitle-2 font-weight-medium"
              >
                {{ slotProps.data.screen.screen.session_status }}
              </v-card-text>
            </v-col>
          </v-row>
        </div>
        <v-row
          class="d-flex justify-space-between pl-3 pr-3"
          v-if="!showMobileView"
          style="font-size:12px;"
        >
          <div class="d-flex align-center" style="width:12%">
            <span>{{ slotProps.data.screen_id }}</span>
          </div>
          <div class="d-flex align-center" style="width:12%">
            <v-btn
              color="black"
              class="white--text text-capitalize mr-4"
              height="26"
              width="80"
              @click="openEmail(slotProps.data.group.contact_email)"
            >
              <v-icon small>mdi-email</v-icon>
              <span class="ml-1">
                Email
              </span>
            </v-btn>
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ slotProps.data.uuid }}
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ slotProps.data.uuid }}
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ slotProps.data.destination }}
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ setTime(slotProps.data.start_at) }}
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ setTime(slotProps.data.expected_end_at) }}
          </div>
          <div class="d-flex align-center" style="width:12%">
            {{ slotProps.data.screen.session_status }}
          </div>
        </v-row>
      </template>
    </tables>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Tables from '@/components/app/Table';
import { MobileView } from '@/mixins';

export default {
  components: {
    Tables,
  },
  data: () => ({
    reconHeaders: [
      'Device',
      'Contact',
      'Originating Location',
      'RA#',
      'Destination Location',
      'Rental Date',
      'Due Date',
      'Rental Status',
    ],
  }),
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _dataset: 'reconciliation/getOneWayInstances',
      _getQueryParams: 'reconciliation/getQueryParams',
    }),
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      _setQueryParams: 'reconciliation/setQueryParams',
    }),
    setTime(date) {
      return moment.unix(date).format('YYYY-MM-DD');
    },
    openEmail(email) {
      this.$router.shouldRoute = false;
      window.location.href = `mailto:${email}`;
    },
  },
};
</script>
